import { Stack } from '@mui/material';
import { resolveValidationPriorityMeta } from '../validationConstants';
import { WorkspaceStatusPill } from '../../../shared/ui/workflow/WorkflowWorkspacePrimitives';
import ActionHelpTooltip from '../../../shared/ui/common/ActionHelpTooltip';
import { createActionHelp } from '../../../shared/ui/common/helpModel';

interface ValidationPriorityBadgeProps {
  validationIds: number[] | number;
  compact?: boolean;
  showRank?: boolean;
}

export default function ValidationPriorityBadge({
  validationIds,
  compact = false,
  showRank = true,
}: ValidationPriorityBadgeProps) {
  const meta = resolveValidationPriorityMeta(validationIds);
  const priorityHelp =
    meta.urgencyLabel === 'Fix now'
      ? createActionHelp('Fix now', meta.urgencyDescription, {
          why: 'PipeEX uses validation priority to order repair work when severity alone does not determine the order.',
        })
      : meta.urgencyLabel === 'High priority'
        ? createActionHelp('High priority', meta.urgencyDescription, {
            why: 'PipeEX uses validation priority to order repair work when severity alone does not determine the order.',
          })
        : meta.urgencyLabel === 'Address soon'
          ? createActionHelp('Address soon', meta.urgencyDescription, {
              why: 'PipeEX uses validation priority to order repair work when severity alone does not determine the order.',
            })
          : createActionHelp('Can wait', meta.urgencyDescription, {
              why: 'PipeEX uses validation priority to order repair work when severity alone does not determine the order.',
            });

  const tone = (() => {
    switch (meta.tone) {
      case 'critical':
      case 'error':
        return 'error' as const;
      case 'warning':
        return 'warning' as const;
      default:
        return 'info' as const;
    }
  })();

  return (
    <ActionHelpTooltip help={priorityHelp} placement="bottom-start">
      <Stack direction="row" spacing={compact ? 0.45 : 0.55} alignItems="center" flexWrap="wrap" useFlexGap>
        {showRank ? <WorkspaceStatusPill label={`Priority #${meta.rank}`} tone={tone} /> : null}
        <WorkspaceStatusPill label={meta.urgencyLabel} tone={tone} />
      </Stack>
    </ActionHelpTooltip>
  );
}
